import React, { Component } from 'react';
import styled from 'styled-components';
import LazyLoad from 'react-lazyload';

import Header from './components/Header'
import Intro from './components/Intro'
import Jobs from './components/Jobs'
import Studies from './components/Studies'
import Portfolio from './components/Portfolio'

const Content = styled.div`
  visibility: ${({visible}) => visible ? 'visible' : 'hidden'};
  opacity: ${({visible}) => visible ? 1 : 0};
  transition: opacity .8s linear;
`

const NAME = 'Michele';
const SURNAME = 'Di Salvatore';
const JOB_TITLE = 'Software Engineer: Front End & JavaScript';

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isContentVisible: false
    }
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        isContentVisible: true,
      })
    }, 800)
  }

  render() {
    return (
      <Content visible>
        <Header name={NAME} surname={SURNAME} jobTitle={JOB_TITLE} />
        <Intro />
        <LazyLoad height={1500} offset={200} once>
          <Jobs />
        </LazyLoad>
        <LazyLoad height={1000} offset={200} once>
          <Studies />
        </LazyLoad>
        <LazyLoad height={250} offset={200} once>
          <Portfolio />
        </LazyLoad>
      </Content>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js